import {useState, useEffect} from 'react';
import "./collapsible.css";

interface iProps {
  id?: number;
  children: JSX.Element;
  buttonLabel: string;
  className?: string;
  buttonClass?: string;
  initiallyOpen?: boolean;
  onClickCallback?: Function;
}

export default function Collapsible(props: iProps) {
  const [open, setOpen] = useState(props.initiallyOpen);

  const toggle = () => {
    if (!open && props.onClickCallback) {
      props.onClickCallback(props.id);
    }
    setOpen(!open);
  }

  useEffect(() => setOpen(props.initiallyOpen ?? false), [props.initiallyOpen]);

  const className = props.className ?? ''
  const buttonClass = props.buttonClass ?? '';
  return (
    <div className={`collapsible ${className}`}>
      <button onClick={toggle} className={open ? `${buttonClass} active` : buttonClass}>{props.buttonLabel}</button>
      <div id="foo" className={open ? "content open" : "content"}>
        {props.children}
      </div>
    </div>
  );
}